import { render, staticRenderFns } from "./importClueContent.vue?vue&type=template&id=5fc9864a&scoped=true"
import script from "./importClueContent.vue?vue&type=script&lang=js"
export * from "./importClueContent.vue?vue&type=script&lang=js"
import style0 from "./importClueContent.vue?vue&type=style&index=0&id=5fc9864a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9864a",
  null
  
)

export default component.exports